/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface UpdateContactScriptManifestRequest
 */
export interface UpdateContactScriptManifestRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateContactScriptManifestRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContactScriptManifestRequest
     */
    source?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContactScriptManifestRequest
     */
    trigger?: string;
}

/**
 * Check if a given object implements the UpdateContactScriptManifestRequest interface.
 */
export function instanceOfUpdateContactScriptManifestRequest(value: object): boolean {
    return true;
}

export function UpdateContactScriptManifestRequestFromJSON(json: any): UpdateContactScriptManifestRequest {
    return UpdateContactScriptManifestRequestFromJSONTyped(json, false);
}

export function UpdateContactScriptManifestRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateContactScriptManifestRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'source': json['source'] == null ? undefined : json['source'],
        'trigger': json['trigger'] == null ? undefined : json['trigger'],
    };
}

export function UpdateContactScriptManifestRequestToJSON(value?: UpdateContactScriptManifestRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'source': value['source'],
        'trigger': value['trigger'],
    };
}

